import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import * as React from "react";
import { ZUid } from "src/types/zUid";
import { Bom2aPosCopyFrom } from "./Bom2aPosCopyFrom";
import { BomPosCopyTo } from "./Bom2aPosCopyTo/Bom2aPosCopyTo";

interface PropsBom2aPosActions {
  modelObjectId: ZUid | undefined;
  objectServiceId: ZUid;
  currentBomId: ZUid;
  selectedPositions: ZUid[];
  reloadPositions: () => void;
}

export const Bom2aPosActions: React.FC<PropsBom2aPosActions> = (props) => {
  const {
    modelObjectId,
    objectServiceId,
    currentBomId,
    selectedPositions,
    reloadPositions,
  } = props;
  const menuProps: MenuProps = {
    items: [
      {
        key: "copyTo",
        label: modelObjectId ? (
          <BomPosCopyTo
            modelObjectId={modelObjectId}
            objectServiceId={objectServiceId}
            targetBomId={currentBomId}
            selectedPosIds={selectedPositions}
            onFinish={reloadPositions}
          />
        ) : (
          "..."
        ),
      },
      {
        key: "copyFrom",
        label: modelObjectId ? (
          <Bom2aPosCopyFrom
            modelObjectId={modelObjectId}
            objectServiceId={objectServiceId}
            targetBomId={currentBomId}
            onFinish={reloadPositions}
          />
        ) : (
          "..."
        ),
      },
    ],
  };
  return (
    <Dropdown menu={menuProps} placement="bottomRight">
      <Button icon={<MoreOutlined />} />
    </Dropdown>
  );
};
